export type AppLanguage = 'en' | 'pl';

import { resolveLanguage } from '@forma/i18n';
export { resolveLanguage } from '@forma/i18n';

export function getBrowserLanguages() {
  if (typeof navigator === 'undefined') {
    return ['en-US'];
  }

  if (navigator.languages?.length > 0) {
    return navigator.languages;
  }

  return [navigator.language || 'en-US'];
}

export function getInitialAppLanguage(preferredLanguage?: unknown) {
  return resolveLanguage(preferredLanguage, getBrowserLanguages());
}

export function getLocaleForLanguage(language: AppLanguage) {
  return language === 'pl' ? 'pl-PL' : 'en-US';
}
